document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.product__info-container');
  const selectors = container.querySelectorAll('.formation-select');

  function updateFormationSelectors(value) {
    const index = parseInt(value);
    selectors.forEach((el, i) => {
      el.style.display = i < index ? 'block' : 'none';
    });
  }

  function attachListenerToVariantSelects() {
    const variantSelects = container.querySelector('variant-selects');
    if (!variantSelects) return;

    const fieldset = variantSelects.querySelector('fieldset');
    if (!fieldset || fieldset.dataset.listenerAttached === 'true') return;

    fieldset.dataset.listenerAttached = 'true';

    fieldset.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"]')) {
        updateFormationSelectors(e.target.value);
      }
    });

    const checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) {
      updateFormationSelectors(checked.value);
    }
  }

  const observer = new MutationObserver(() => {
    attachListenerToVariantSelects();
  });

  observer.observe(container, { childList: true, subtree: true });

  // Premier chargement
  attachListenerToVariantSelects();
});